import * as React from 'react'
import { get } from 'lodash-es'

import { IItem } from '../../../../typings/searchResults'
import Button from '../../button'

import * as styles from './itemCardMinimal.module.css'

interface IProps {
  item: IItem
}

const ItemCardMinimal = ({ item }: IProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.img} />
      <h3 className={styles.title}>
        <a href={item.url} className={styles.titleLink}>
          {item.name}
        </a>
      </h3>
      <a href={item.author_url} className={styles.author}>
        {item.author_username}
      </a>
      <div className={styles.price}>${item.price_cents / 100}</div>
      <div className={styles.sales}>
        Sales: {Math.round(item.number_of_sales / 100)}K
      </div>
      <div className={styles.buttons}>
        <Button href={get(item, 'previews.live_site.url')}>Preview</Button>
        <Button
          href={`/cart/configure_before_adding/${item.id}`}
          type={Button.Type.Primary}
        >
          Add to Cart
        </Button>
      </div>
    </div>
  )
}

export default ItemCardMinimal
